import { gql } from 'apollo-boost';
import { READ_ONLY_URL_META_FIELDS } from '../../fragments/message/read-only-url-meta-fields';
import { STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/structured-content-fields';
import { TRANSCRIPT_FIELDS } from '../../fragments/message/transcript-fields';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const GET_SHARED_FOLDER_CONTENT = gql`
    query getSharedFolderContent($data: GetSharedFolderContentInput!) {
        getSharedFolderContent(data: $data) {
            folder {
                ...FolderCacheSafeFields
            }
            folders {
                ...FolderCacheSafeFields
            }
            viewerCanCreateSubfolders
            viewerCanContribute
            messages {
                messages {
                    id
                    title
                    body
                    createdAt
                    image {
                        url
                        cdn_url
                        thumbnail {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                        name
                        displayName
                        type
                        format
                        width
                        height
                    }
                    file {
                        url
                        cdn_url
                        name
                        displayName
                        type
                        format
                        size
                        mime
                    }
                    ${READ_ONLY_URL_META_FIELDS}
                    caption
                    ${TRANSCRIPT_FIELDS}
                    ${STRUCTURED_CONTENT_FIELDS}
                    type {
                        type
                    }
                    sourceHost
                    sourceUrls
                    canonicalSourceUrls
                }
                cursor
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;
